import type { App } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'

import CBreadCrumb from '@/components/common/CBreadcrumb.vue'
import SmartBreadcrumb from '@/components/common/SmartBreadcrumb.vue'
import CTable from '@/components/common/CTable.vue'
import CInput from '@/components/common/CInput.vue'
import CollapseCriteria from '@/components/base/CollapseCriteria.vue'
import CButton from '@/components/common/CButton.vue'
import CSelect from '@/components/common/CSelect.vue'
import CDirectoryTree from '@/components/common/CDirectoryTree.vue'
import CRangePicker from '@/components/common/CRangeDatePicker.vue'
import CNumberInput from '@/components/common/CInputNumber.vue'
import CDropdown from '@/components/common/CDropdown.vue'
import CStaff from '@/components/common/CStaff.vue'
import COrgStaff from '@/components/common/COrgStaff.vue'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
export default {
  install(app: App) {
    app.component('QuillEditor', QuillEditor)
    app.component('CBreadCrumb', CBreadCrumb)
    app.component('CTable', CTable)
    app.component('CInput', CInput)
    app.component('CNumberInput', CNumberInput)
    app.component('CollapseCriteria', CollapseCriteria)
    app.component('CButton', CButton)
    app.component('CSelect', CSelect)
    app.component('CDirectoryTree', CDirectoryTree)
    app.component('CRangePicker', CRangePicker)
    app.component('CDropdown', CDropdown)
    app.component('CStaff', CStaff)
    app.component('COrgStaff', COrgStaff)
    app.component('SmartBreadcrumb', SmartBreadcrumb)
  },
}
